import { LocalesConfigInterface } from '../../interfaces';

export function getLangList(): LocalesConfigInterface {
  return {
    en: {
      name: 'English',
      dateFormatShort: 'dd/mm/yyyy',
      dateFormatShortMoment: 'DD/MM/YYYY',
      dateMonthFormatShort: 'mm/yyyy',
      dateMonthFormatShortMoment: 'MM/YYYY',
      dateLongFormatMoment: 'dddd Do MMMM',
      dateTimeFormat: 'd MMMM yyyy HH:mm',
      thousandsSeparatorSymbol: ',',
      decimalSymbol: '.',
    },
    de: {
      name: 'Deutsch',
      dateFormatShort: 'dd.mm.yyyy',
      dateFormatShortMoment: 'DD.MM.YYYY',
      dateMonthFormatShort: 'mm.yyyy',
      dateMonthFormatShortMoment: 'MM.YYYY',
      dateLongFormatMoment: 'dddd Do MMMM',
      dateTimeFormat: 'd MMMM yyyy HH:mm',
      thousandsSeparatorSymbol: '.',
      decimalSymbol: ',',
    },
    es: {
      name: 'Español',
      dateFormatShort: 'dd/mm/yyyy',
      dateFormatShortMoment: 'DD/MM/YYYY',
      dateMonthFormatShort: 'mm/yyyy',
      dateMonthFormatShortMoment: 'MM/YYYY',
      dateLongFormatMoment: 'dddd Do MMMM',
      dateTimeFormat: 'd MMMM yyyy HH:mm',
      thousandsSeparatorSymbol: '.',
      decimalSymbol: ',',
    },
    no: {
      name: 'Norsk',
      dateFormatShort: 'dd/mm/yyyy',
      dateFormatShortMoment: 'DD/MM/YYYY',
      dateMonthFormatShort: 'mm/yyyy',
      dateMonthFormatShortMoment: 'MM/YYYY',
      dateLongFormatMoment: 'dddd Do MMMM',
      dateTimeFormat: 'd MMMM yyyy HH:mm',
      thousandsSeparatorSymbol: ' ',
      decimalSymbol: ',',
    },
    da: {
      name: 'Dansk',
      dateFormatShort: 'dd/mm/yyyy',
      dateFormatShortMoment: 'DD/MM/YYYY',
      dateMonthFormatShort: 'mm/yyyy',
      dateMonthFormatShortMoment: 'MM/YYYY',
      dateLongFormatMoment: 'dddd Do MMMM',
      dateTimeFormat: 'd MMMM yyyy HH:mm',
      thousandsSeparatorSymbol: '.',
      decimalSymbol: ',',
    },
    sv: {
      name: 'Svenska',
      dateFormatShort: 'dd/mm/yyyy',
      dateFormatShortMoment: 'DD/MM/YYYY',
      dateMonthFormatShort: 'mm/yyyy',
      dateMonthFormatShortMoment: 'MM/YYYY',
      dateLongFormatMoment: 'dddd Do MMMM',
      dateTimeFormat: 'd MMMM yyyy HH:mm',
      thousandsSeparatorSymbol: ' ',
      decimalSymbol: ',',
    },
    nl: {
      name: 'Dutch',
      dateFormatShort: 'dd-mm-yyyy',
      dateFormatShortMoment: 'DD-MM-YYYY',
      dateMonthFormatShort: 'mm/yyyy',
      dateMonthFormatShortMoment: 'MM/YYYY',
      dateLongFormatMoment: 'dddd Do MMMM',
      dateTimeFormat: 'd MMMM yyyy HH:mm',
      thousandsSeparatorSymbol: '.',
      decimalSymbol: ',',
    },
    fr: {
      name: 'French',
      dateFormatShort: 'dd/mm/yyyy',
      dateFormatShortMoment: 'DD/MM/YYYY',
      dateMonthFormatShort: 'mm/yyyy',
      dateMonthFormatShortMoment: 'MM/YYYY',
      dateLongFormatMoment: 'dddd Do MMMM',
      dateTimeFormat: 'd MMMM yyyy HH:mm',
      thousandsSeparatorSymbol: ' ',
      decimalSymbol: ',',
    },
  };
}
